import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import PatternsUtils from '../utils/patterns.utils';

/**
 * Valida quantidade mínima de caracteres (ex: nome + sobrenome, 2 chars cada).
 */
export function textMinCharsValidator(): ValidatorFn {
  const regex = PatternsUtils.FULL_NAME_MIN_2_CHARS;
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim();
    if (!value) return null; // "required" cuida do vazio
    return regex.test(value) ? null : { textMinChars: true };
  };
}

export function corporateNameValidator(minChars = 2): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = (control.value || '').toString();
    const value = raw.trim();


    if (!value) return null;


    const forbidden = /[\r\n\t\0]/;
    if (forbidden.test(value)) {
      return { corporateNameInvalidChars: true };
    }


    const lengthWithoutExtraSpaces = value.replace(/\s+/g, ' ').length;
    if (lengthWithoutExtraSpaces < minChars) {
      return { corporateNameMinLength: { required: minChars } };
    }

    return null;
  };
}

/**
 * Valida que o campo não tenha números nem caracteres especiais.
 */
export function textNoSpecialCharsValidator(): ValidatorFn {
  const regex = PatternsUtils.NO_SPECIAL_CHARS;
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim();
    if (!value) return null;
    return regex.test(value) ? null : { textInvalidChars: true };
  };
}





export function emailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = (control.value || '').trim();
  if (!value) {
    return null;
  }


  const regex = /^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;

  if (!regex.test(value)) {
    return { email: true };
  }

  const domain = value.split('@')[1].toLowerCase();

  const lastDotIndex = domain.lastIndexOf('.');
  if (lastDotIndex === -1) {

    return { email: true };
  }

  const tld = domain.slice(lastDotIndex + 1);


  if (tld.startsWith('con')) {
    return { email: true };
  }

  return null;
}

export function sanitizeName(value: string): string {
  if (!value) return value;

  return value
    .replace(/[^\p{L}'\s]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/g, '');
}


export function addNameSanitizers(
  form: FormGroup,
  options?: {
    groupPath?: string | (string | number)[];
    controlNames?: string[];
    timeoutMs?: number;
  },
  fisica: boolean = false,
  index?: number,
): void {
  // se não tiver groupPath, usa o form raiz
  const groupPath = options?.groupPath;
  const controlNames =
    options?.controlNames ?? ['name_mother_father', 'name_mother_father_optional', 'name'];
  const timeoutMs = options?.timeoutMs ?? 5000;

  const group = groupPath
    ? (form.get(groupPath) as FormGroup)
    : (form as FormGroup); // raiz

  if (!group) return;

  controlNames.forEach((controlName) => {
    const control = group.get(controlName);
    if (!control) return;

    let typingTimeout: any;

    control.valueChanges.subscribe((value: string) => {
      if(fisica){
         const type = group.get(`type${index}`)?.value;
       if (type !== 'fisica') return;
      }
      if (value == null) return;

      const sanitized = sanitizeName(value);
      if (sanitized !== value) {
        control.setValue(sanitized, { emitEvent: false });
      }

      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      typingTimeout = setTimeout(() => {
        const current = control.value as string;
        if (!current) return;

        const trimmedEnd = current.replace(/\s+$/g, '');
        if (trimmedEnd !== current) {
          control.setValue(trimmedEnd, { emitEvent: false });
        }
      }, timeoutMs);
    });
  });
}

export function sanitizeCorporateName(value: string): string {
  if (!value) return value;

  return value
    .replace(/\s{2,}/g, ' ')  // colapsa múltiplos espaços em 1
    .replace(/^\s+/g, '');    // remove espaços do início

}

export function addCorporateNameSanitizer(
  form: FormGroup,
  options?: {
    groupPath?: string | (string | number)[];
    controlNames?: string[];
    timeoutMs?: number;
  },
  juridica: boolean = false,
  index?: number
): void {

  console.log('entrouu')
  const groupPath = options?.groupPath;
  const controlNames = options?.controlNames ?? ['corporateName'];
  const timeoutMs = options?.timeoutMs ?? 5000;

  const group = groupPath
    ? (form.get(groupPath) as FormGroup)
    : (form as FormGroup);

  if (!group) return;

  controlNames.forEach((controlName) => {


    const control = group.get(controlName);
    if (!control) return;

    let typingTimeout: any;

    control.valueChanges.subscribe((value: string) => {
        if(juridica){
      const type = group.get(`type${index}`)?.value;
          if (type !== 'juridica') return;
    }
      if (value == null) return;

      // usa o sanitizer específico de razão social
      const sanitized = sanitizeCorporateName(value);
      if (sanitized !== value) {
        control.setValue(sanitized, { emitEvent: false });
      }

      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      // depois de 5000 ms, remove espaços NO FIM
      typingTimeout = setTimeout(() => {
        const current = control.value as string;
        if (!current) return;

        const trimmedEnd = current.replace(/\s+$/g, '');
        if (trimmedEnd !== current) {
          control.setValue(trimmedEnd, { emitEvent: false });
        }
      }, timeoutMs);
    });
  });
}
